import Image from "next/image";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const ParallaxImageSection = ({
  src,
  alt,
  children,
}: {
  src: string;
  alt: string;
  children: React.ReactNode;
}) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'], // triggers as it enters viewport
  });

  const y = useTransform(scrollYProgress, [0, 1], ['-30%', '30%']);

  return (
    <div
      ref={ref}
      className="relative h-[400px] md:h-[600px] overflow-hidden flex items-center justify-center"
    >
      <motion.div
        className="absolute -inset-24 z-0"
        style={{ y }}
      >
        <Image
          src={src}
          alt={alt}
          fill
          priority
          style={{ objectFit: "cover", objectPosition: "center" }}
        />
        <div className="absolute inset-0 bg-black/20 z-10" />
      </motion.div>

      <div className="z-10 text-white text-center px-4">{children}</div>
    </div>
  );
};

export default ParallaxImageSection;
